import React, { useRef, useEffect, Fragment } from "react"
import { useTranslation } from "react-i18next"

import { store } from "@redux"
import { getOrders } from "services"
import KtOrderCard from "./KtOrderCard"
import { socketConnection } from "utils"
import { Button, Spinner } from "components"
import classes from "./index.module.scss"

const KtOrders = props => {
  const {
    selectedTableId,
    tableDetails,
    tableOrders,
    setTableOrders,
    selectedOrders,
    setSelectedOrders,
    showMoveTableMessage,
    setShowMoveTableMessage
  } = props

  const [t] = useTranslation()

  const unmount = useRef(false)

  const getPreviouslyStoredOrders = () => {
    const {
      ordersOfOrderPage,
      offlineOrders
    } = store.getState()

    const tableOrders =
      ordersOfOrderPage.orders.filter(order =>
        order.orderStatus === "pending" &&
        order.tableNumber === tableDetails.tableNumber &&
        !offlineOrders.some(offlineOrder =>
          offlineOrder.onlineOrderId === order._id
        )
      )

    setTableOrders(tableOrders)
  }

  const handleTableOrderChanges = (jsonMessage) => {
    const message = JSON.parse(jsonMessage)

    const event = message.key

    if (event === "paymentCreated") {
      const order = message.value

      setTableOrders(prev =>
        prev.map(tableOrder =>
          tableOrder._id === order._id
            ? order
            : tableOrder
        )
      )

      return
    }

    if (event === "orderDeleted") {
      setTableOrders(prev =>
        prev.filter(tableOrder =>
          tableOrder._id !== message.value._id
        )
      )

      return
    }

    const order = message.value.order

    const validOrderTable =
      order?.isCod &&
      order.deliveryType === "dineIn" &&
      order.tableNumber === tableDetails.tableNumber

    if (!validOrderTable) return

    if (event === "orderCreated") {
      setTableOrders(prev => [order, ...prev])

      return
    }

    if (event === "orderUpdated") {
      setTableOrders(prev =>
        prev.map(tableOrder =>
          tableOrder._id === order._id
            ?
            {
              ...tableOrder,
              ...order
            }
            : tableOrder
        )
      )

      return
    }
  }

  const getTableOrders = async () => {
    setTableOrders(null)

    setSelectedOrders({})

    try {
      const response =
        await getOrders({
          skip: 0,
          limit: 20,
          sortBy: "newstOrder",
          statusMultiple: ["pending"],
          tableNumber: tableDetails.tableNumber
        })

      if (unmount.current) return

      setTableOrders([...response])
    } catch (err) {
      getPreviouslyStoredOrders()

      console.log(err)
    }
  }

  useEffect(() => {
    getTableOrders()
  }, [selectedTableId])

  useEffect(() => {
    const socket = socketConnection.getSocket()

    socket.on("basicEmit", handleTableOrderChanges)

    unmount.current = false

    return () => {
      unmount.current = true

      socket.removeListener("basicEmit", handleTableOrderChanges)
    }
  }, [])

  const showTableOrderEditButton =
    Object.keys(selectedOrders).length === 0

  return (
    <div className={classes["container"]}>
      {
        !showMoveTableMessage &&
        <Fragment>
          {tableOrders !== null
            ?
            tableOrders.length !== 0
              ?
              tableOrders.map(tableOrder =>
                <KtOrderCard
                  key={tableOrder._id}
                  tableOrder={tableOrder}
                  setTableOrders={setTableOrders}
                  tableDetails={tableDetails}
                  isSelected={selectedOrders[tableOrder._id]}
                  showEditButton={showTableOrderEditButton}
                  setSelectedOrders={setSelectedOrders}
                />
              )
              :
              <div className={classes["center"]}>
                {t("هیج_سفارشی_ثبت_نشده")}
              </div>
            :
            <div className={classes["center"]}>
              <Spinner
                size={20}
                color="var(--color-primary)"
              />
            </div>
          }
        </Fragment>
      }
      {
        showMoveTableMessage &&
        <div className={classes["center"]}>
          <div className={classes["textCenter"]}>
            {t("میز_تان_را_از_سمت_راست_انتخاب_کنید")}
          </div>
          <Button
            color="danger"
            onClick={() => setShowMoveTableMessage(false)}
          >
            {t("انصراف_از_انتخاب")}
          </Button>
        </div>
      }
    </div>
  )
}

export default KtOrders